import {
  AgentProfile,
  AppPresence,
  GuestProfile,
  LimitedAgentProfile
} from "@closerplatform/spinner-openapi";

import { UserProfile } from "../models/userProfile";

export interface IUserService {
  getAgent(id: string): AgentProfile | LimitedAgentProfile | undefined;
  getGuest(id: string): GuestProfile | undefined;
  getUser(id: string): UserProfile | undefined;
  getCurrentUser(): UserProfile;
  getBotProfile(): AgentProfile | LimitedAgentProfile;
}

export abstract class AbstractUserService implements IUserService {
  private static readonly DEFAULT_BOT_PROFILE: AgentProfile = {
    id: "lekta",
    firstName: "Automatic",
    lastName: "Receptionist",
    isBot: true,
    presence: AppPresence.Available,
    email: "",
    isActive: true,
    orgRole: "bot",
    tagGroups: [],
    tags: [],
    groups: []
  };

  abstract getAgent(id: string): AgentProfile | LimitedAgentProfile | undefined;
  abstract getGuest(id: string): GuestProfile | undefined;
  abstract getCurrentUser(): UserProfile;
  protected abstract getBotProfileId(): string | undefined;

  getUser(id: string) {
    return this.getGuest(id) || this.getAgent(id);
  }

  getBotProfile() {
    const botId = this.getBotProfileId();
    return (botId && this.getAgent(botId)) || AbstractUserService.DEFAULT_BOT_PROFILE;
  }
}
